import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./ProductListGroup.scss";
import { Image, ListGroup } from "react-bootstrap";
import { getProductPrice, icons } from "@/utils/constants";
import { QuantitySelector } from "../../Product/QuantitySelector/QuantitySelector";
import { setCart, setShowToast, setToastMessage, } from "@/utils/constants/redux/sets";
export const ProductListGroup = ({ cart }) => {
    const deleteItem = (item) => {
        setCart(cart.filter((cartItem) => cartItem.id !== item.id));
        setShowToast(true);
        setToastMessage("Producto eliminado del carrito");
    };
    return (_jsx(ListGroup, { children: cart.map((item) => (_jsxs(ListGroup.Item, { className: "d-flex justify-content-between align-items-start fmc-cart-item", children: [_jsx(Image, { src: item.imageUrl, className: "fmc-cart-img-product", alt: item.name }), _jsxs("div", { className: "ms-2 me-auto", children: [_jsx("div", { className: "fw-bold", children: item.name }), "Molienda: ", item.grinding, _jsx("br", {}), "$ ", item.price, " Und", _jsx(QuantitySelector, { quantity: item.quantity, setQuantity: (quantity) => {
                                if (quantity === 0) {
                                    deleteItem(item);
                                    return;
                                }
                                const newCart = cart.map((cartItem) => cartItem.id === item.id
                                    ? { ...cartItem, quantity }
                                    : cartItem);
                                setCart(newCart);
                            }, isCart: true })] }), _jsxs("div", { className: "product-price is-product-detail", children: ["$ ", getProductPrice(item)] }), _jsx("button", { className: "fmc-cart-delete-btn", onClick: () => deleteItem(item), title: "Eliminar producto", children: _jsx(Image, { src: icons.DeletePurple, alt: "Eliminar" }) })] }, item.id))) }));
};
